import { v4 as uuidv4 } from 'uuid'

/**
 * Gives each of a page's items an id no other item on the line holds. A
 * persisted id is kept rather than re-minted, because an item id keys its
 * editor text-box rows; ids share one keyspace across pages, so an item
 * stored without an id, or with an id an earlier page already holds, gets a
 * new one. Answers the ids it minted: the stored page JSON does not hold
 * them until a Save writes the page.
 */
export const deCollideEditorItemIds = (
  items: Array<{ id?: string }>,
  seenItemIds: Set<string>,
): string[] => {
  const minted: string[] = []
  for (const item of items) {
    if (!item.id || seenItemIds.has(item.id)) {
      item.id = uuidv4()
      minted.push(item.id)
    }
    seenItemIds.add(item.id)
  }
  return minted
}
